import { useLang, LANGS } from "../i18n";
import { Globe } from "lucide-react";

export function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center gap-1 border border-[#1E2028] bg-[#0F1015] px-1 py-1" data-testid="lang-switcher">
      <Globe className="w-3.5 h-3.5 text-[#6B7280] ml-1" />
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          className={`px-2 py-0.5 text-xs font-mono transition-colors duration-200 ${
            lang === l.code ? "bg-[#FACC15] text-[#05050A] font-semibold" : "text-[#9CA3AF] hover:text-white"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}

export function Logo({ small }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="app-logo">
      <div className={`grid place-items-center bg-[#FACC15] text-[#05050A] font-display font-black ${small ? "w-7 h-7 text-sm" : "w-9 h-9 text-lg"}`}>
        A
      </div>
      <div className="leading-none">
        <div className={`font-display font-black tracking-tight ${small ? "text-base" : "text-lg"}`}>AURORA</div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#FACC15] font-mono">Trader AI</div>
      </div>
    </div>
  );
}
